import { Injectable, inject} from '@angular/core';
import { env } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class tableDataService {

  private http = inject(HttpClient);
  private baseUrl = `${env.api.baseUrlProtected}/collezione-digitale`;


 getAllCollezioni(data: Record<string, string | number | boolean> = {}): Observable<any> {
  return this.http.get(`${this.baseUrl}`, { params: data });
}

deleteCollezione(id: string): Observable<any> {
  return this.http.delete(`${this.baseUrl}/${id}`);
}


}
